/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type ProlongSessionMutationVariables = Types.Exact<{
  input: Types.ProlongTemporaryBackofficeSessionInput
}>

export type ProlongSessionMutation = {
  __typename?: 'Mutation'
  prolongTemporaryBackofficeSession: {
    __typename?: 'TemporaryBackofficeSession'
    id: string
    expiresAt: string
  }
}

export const ProlongSessionDocument = gql`
    mutation ProlongSession($input: ProlongTemporaryBackofficeSessionInput!) {
  prolongTemporaryBackofficeSession(input: $input) {
    id
    expiresAt
  }
}
    `
export type ProlongSessionMutationFn = Apollo.MutationFunction<
  ProlongSessionMutation,
  ProlongSessionMutationVariables
>

/**
 * __useProlongSessionMutation__
 *
 * To run a mutation, you first call `useProlongSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProlongSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prolongSessionMutation, { data, loading, error }] = useProlongSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProlongSessionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ProlongSessionMutation,
    ProlongSessionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ProlongSessionMutation,
    ProlongSessionMutationVariables
  >(ProlongSessionDocument, options)
}
export type ProlongSessionMutationHookResult = ReturnType<
  typeof useProlongSessionMutation
>
export type ProlongSessionMutationResult =
  Apollo.MutationResult<ProlongSessionMutation>
export type ProlongSessionMutationOptions = Apollo.BaseMutationOptions<
  ProlongSessionMutation,
  ProlongSessionMutationVariables
>
